import { render, staticRenderFns } from "./PaypalAccountForm.vue?vue&type=template&id=d15fd5fa&scoped=true"
import script from "./PaypalAccountForm.vue?vue&type=script&lang=js"
export * from "./PaypalAccountForm.vue?vue&type=script&lang=js"
import style0 from "./PaypalAccountForm.vue?vue&type=style&index=0&id=d15fd5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15fd5fa",
  null
  
)

export default component.exports